import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { Form, Radio, Card } from "antd";
import { FormContentBlockerLayout } from "../..";
import { useI18n, useUpsell } from "../../../../../contexts";
import { useUpsellModalVisualContentBlocker } from "../../../../../hooks";
const FormContentBlockerFieldVisualType = ()=>{
    const { __ } = useI18n();
    const { isPro } = useUpsell();
    const { modal, tag } = useUpsellModalVisualContentBlocker();
    const visualTypes = useMemo(()=>({
            default: {
                title: __("Textbox"),
                description: __("Plain text with button")
            },
            wrapped: {
                title: __("Wrapped"),
                description: __("Image surrounding the content blocker")
            },
            hero: {
                title: __("Hero"),
                description: __("Image with content blocker on click")
            }
        }), [
        __
    ]);
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.isVisual !== nextValues.isVisual,
        children: (param)=>{
            let { getFieldValue } = param;
            return !!getFieldValue("isVisual") && /*#__PURE__*/ _jsx(Form.Item, {
                wrapperCol: {
                    offset: FormContentBlockerLayout.labelCol.span
                },
                style: {
                    paddingBottom: 10
                },
                children: /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx(Form.Item, {
                        name: "visualType",
                        noStyle: true,
                        rules: isPro ? [] : [
                            {
                                required: true,
                                type: "enum",
                                enum: [
                                    "default"
                                ],
                                message: __("This type of visual content blocker is available only in the PRO version of the plugin. Please choose a textbox content blocker!")
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Radio.Group, {
                            size: "large",
                            buttonStyle: "solid",
                            className: "rcb-antd-radio-button-card",
                            style: {
                                marginBottom: 10
                            },
                            children: Object.keys(visualTypes).map((type)=>{
                                const { description, title } = visualTypes[type];
                                return /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: type,
                                    children: /*#__PURE__*/ _jsx(Card, {
                                        style: {
                                            width: 300
                                        },
                                        bordered: false,
                                        cover: /*#__PURE__*/ _jsx("img", {
                                            style: {
                                                height: 168.75
                                            },
                                            src: `https://assets.devowl.io/in-app/wp-real-cookie-banner/visual-content-blocker-preview/${type}.png`
                                        }),
                                        children: /*#__PURE__*/ _jsx(Card.Meta, {
                                            title: /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    modal,
                                                    title,
                                                    " ",
                                                    type !== "default" && tag
                                                ]
                                            }),
                                            description: description
                                        })
                                    })
                                }, type);
                            })
                        })
                    })
                })
            });
        }
    });
};
export { FormContentBlockerFieldVisualType };
